
export default class Tool{

    /**
     * 设置本地存储
     * @param key
     * @param value
     * @param second 【存储时长，秒数】
     */
    static setLocalData(key,value,second = null){
        let now = new Date();
        if(second!=null){
            now.setSeconds(now.getSeconds()+second);
        }
        let data = {
            value,
            expires:second==null?second:now.getTime(),
        };
        localStorage.setItem(process.env["VUE_APP_LOCAL_PREFIX"]+key,JSON.stringify(data)) ;
    }

    /**
     * 获取本地存储
     * @param key
     * @returns {null|*}
     */
    static getLocalData(key){
        let data = JSON.parse(localStorage.getItem(process.env["VUE_APP_LOCAL_PREFIX"]+key));
        if (data !== null) {
            if(data.expires==null || data.expires >= new Date().getTime()){
                return data.value;
            }else{
                localStorage.removeItem(process.env["VUE_APP_LOCAL_PREFIX"]+key);
            }
        }
        return null;
    }

    /**
     * 删除本地存储
     * @param key
     */
    static removeLocalData(key){
        localStorage.removeItem(process.env["VUE_APP_LOCAL_PREFIX"]+key);
    }

    static formatDate(inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // var h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // var minute = date.getMinutes();
        // var second = date.getSeconds();
        // minute = minute < 10 ? ('0' + minute) : minute;
        // second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d
    }

    static setToken(uid){
        this.setLocalData(process.env.VUE_APP_LOCAL_PREFIX+'token',uid);
    }

    static getToken(){
        return this.getLocalData(process.env.VUE_APP_LOCAL_PREFIX+'token');
    }

    static removeToken(){
        return this.removeLocalData(process.env.VUE_APP_LOCAL_PREFIX+'token');
    }

    /**
     * canvas的dataurl转化成File对象
     * @param dataurl
     * @param filename
     * @returns {File}
     */
    static dataURLtoFile(dataurl, filename = 'file') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
            type: mime
        })
    }



    /**
     * 随机整数
     * @param minNum
     * @param maxNum
     * @return {number}
     */
    static randomNum(minNum,maxNum){
        switch(arguments.length){
            case 1:
                return parseInt(Math.random()*minNum+1,10);
                break;
            case 2:
                return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
                break;
            default:
                return 0;
                break;
        }
    }

}
